export default "__VITE_ASSET__fb9bf1e0__"